import type { ValidationMessages } from "@/types";

const validationDE: ValidationMessages = {
    'max_length': '{field} darf maximal 0:{max} Element(e) ausgewählt haben',
    'min_length': '{field} muss mindestens 0:{min} Element(e) ausgewählt haben'
}

export default validationDE
